import { Decimal, MONEY_SCALE, roundMoney, sum, toDecimal } from './money.js';
export function isVatExempt(rate) {
    return rate === null || rate === undefined;
}
/**
 * Посчитать суммы одной строки документа.
 *
 * Начисление сверху:  сумма = кол-во × цена;  НДС = сумма × ставка / 100
 * Выделение из суммы: всего = кол-во × цена;  НДС = всего × ставка / (100 + ставка)
 */
export function calcLine(input) {
    const quantity = toDecimal(input.quantity);
    const price = toDecimal(input.price);
    const gross = quantity.times(price);
    if (isVatExempt(input.vatRateValue)) {
        const amount = roundMoney(gross);
        return { amount, vatAmount: new Decimal(0), totalAmount: amount };
    }
    const rate = toDecimal(input.vatRateValue);
    if (input.priceIncludesVat) {
        // Цена с НДС — налог выделяется расчётным методом
        const totalAmount = roundMoney(gross);
        const vatAmount = roundMoney(totalAmount.times(rate).dividedBy(rate.plus(100)));
        const amount = totalAmount.minus(vatAmount);
        return { amount, vatAmount, totalAmount };
    }
    // Цена без НДС — налог начисляется сверху
    const amount = roundMoney(gross);
    const vatAmount = roundMoney(amount.times(rate).dividedBy(100));
    const totalAmount = amount.plus(vatAmount);
    return { amount, vatAmount, totalAmount };
}
/** Итоги документа — сумма уже округлённых строк, без повторного округления. */
export function calcTotals(lines) {
    const subtotal = sum(lines.map((l) => l.amount));
    const vatAmount = sum(lines.map((l) => l.vatAmount));
    const total = sum(lines.map((l) => l.totalAmount));
    return { subtotal, vatAmount, total };
}
/**
 * Итоги документа со скидкой в процентах (смета, КП).
 *
 * Скидка применяется к цене каждой строки, и строка пересчитывается заново:
 * сумма, НДС и их округление — построчно, как требует правило о НДС. Итог
 * — сумма уже округлённых строк. Процент от общего итога дал бы другой НДС,
 * чем сумма НДС по строкам, если документ потом превратится в счёт или УПД.
 * Строки в таблице при этом остаются по прайсовым ценам, скидка —
 * отдельной строкой под таблицей.
 */
export function calcDiscountedTotals(lines, discountPercent) {
    const before = calcTotals(lines.map(calcLine));
    const percent = discountPercent == null ? new Decimal(0) : toDecimal(discountPercent);
    if (percent.isZero())
        return { ...before, totalBeforeDiscount: before.total, discountAmount: new Decimal(0) };
    const factor = new Decimal(1).minus(percent.dividedBy(100));
    const after = calcTotals(lines.map((line) => calcLine({ ...line, price: toDecimal(line.price).times(factor) })));
    return { ...after, totalBeforeDiscount: before.total, discountAmount: before.total.minus(after.total) };
}
export function calcVatBreakdown(lines) {
    const byRate = new Map();
    for (const line of lines) {
        const existing = byRate.get(line.vatRateCode);
        if (existing) {
            existing.amount = existing.amount.plus(line.amount);
            existing.vatAmount = existing.vatAmount.plus(line.vatAmount);
            existing.totalAmount = existing.totalAmount.plus(line.totalAmount);
        }
        else {
            byRate.set(line.vatRateCode, {
                vatRateCode: line.vatRateCode,
                amount: line.amount,
                vatAmount: line.vatAmount,
                totalAmount: line.totalAmount,
            });
        }
    }
    return [...byRate.values()];
}
export { MONEY_SCALE };
//# sourceMappingURL=vat.js.map